import PaymentMethod from "./enums/PaymentMethod";
import ReservationStatusType from "./enums/ReservationStatusType";
import ReservationType from "./enums/ReservationType";
import IAllReservations from "./interfaces/IAllReservations";
import {DefaultParkingCategory} from "./nominalTypes/ParkingCategory";
import {ParkingType} from "./nominalTypes/ParkingType";
import {ReservationId} from "./nominalTypes/ReservationId";
import {CreateReservationCommand} from "./types/CreateReservationCommand";
import {ReservationResult} from "./types/ReservationResult";

class Reservations {
	static isActive(reservation: ReservationResult): boolean {
		return reservation.status.type === ReservationStatusType.Active;
	}

	static find(permits: IAllReservations, id: ReservationId | undefined): ReservationResult | undefined {
		return id == null ? undefined : permits.reservations.find(reservation => reservation.id === id);
	}

	static newFormContext(parkingType: ParkingType): CreateReservationCommand {
		return {
			customData: [],
			tariffId: null!,
			category: DefaultParkingCategory,
			parkingType: parkingType,
			reservation: {
				arguments: {
					startDate: null!,
					endDate: null!,
					purpose: "",
					type: ReservationType.Undefined,
					blocks: [],
					meters: [],
					customData: [],
					paymentMethod: {method: PaymentMethod.Undefined}
				},
				attachments: {},
				customData: {}
			}
		}
	}
}

export {Reservations};
